/**
 * Usage:
 *
 * data-sw-product-customize=<productSpin>
 *
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-product-customize]').each(function() {
    var $el = $(this);

    require([
      'js/lib/models/ModelManager',
      'js/lib/views/ProductCustomizeSelect'
    ], function(ModelManager, ProductCustomizeSelect) {

      var spin = $el.data('swProductCustomize');
      var product = ModelManager.getProduct(spin);

      new ProductCustomizeSelect({
        el:     $el,
        model:  product
      });

    });
  });

};
